import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/login/login';
import Main from './pages/main/main';
import LoadingPage from './pages/loading/loading';
import { UserDataContext } from './contexts';
import { useUserData } from './hooks';

function App() {
  const {
    status,
    userInfo,
    refetchStatus,
  } = useUserData();

  if (status === 'loading') return <LoadingPage />;

  return (
    <UserDataContext.Provider value={{ 
      refetchStatus,
      userInfo
    }}>
      <BrowserRouter>
        <Routes>
          {
            status === 'error'
              ? (
              <>
                <Route path="/login" element={<Login />} />
                <Route path="*" element={<Navigate to="/login" />} />
              </>
              ) :
              (
              <>
                <Route path="/login" element={<Navigate to="/" />} />
                <Route path="/" element={<Main />} />
              </>
              )
          }
        </Routes>
      </BrowserRouter>
  </UserDataContext.Provider>
  );
}

export default App;

